import * as actionTypes from "../actionTypes";
import axios from "axios";
import { config } from "../../../config/config";

const dashboardDatasStart = () => {
  return {
    type: actionTypes.DASHBOARD_DATAS_START,
  };
};

const dashboardDatasSuccess = (datas) => {
  return {
    datas,
    type: actionTypes.DASHBOARD_DATAS_SUCCESS,
  };
};

const dashboardDatasFailed = (err) => {
  return {
    err,
    type: actionTypes.DASHBOARD_DATAS_FAILED,
  };
};
export const onDashboardDatas = (params, sortParamsBrand, sortParamsSku) => {
  return async (dispatch) => {
    await dispatch(dashboardDatasStart());
    let datas = {};

    const appendParams = (url, params) => {
      if (params) {
        // Check if there are existing query parameters
        const separator = url.includes("?") ? "&" : "?";
        return `${url}${separator}${params}`;
      }
      return url;
    };

    try {
      const [
        dailyItems,
        totalItems,
        detailedBrands,
        detailedItems,
        totalTransaction,
        transactionsPerDay,
        successfulTransactions,
        successfulUploaders,
        multipleUploaders,
        averageTransaction,
        numberOfRegistrations,
        commonInvalidReasons,
        numberOfTransactionsPerBranch,
        adclicksPerRef,
        gCashBalance,
      ] = await axios.all([
        axios.get(appendParams(`${config.productstats}/daily-items`, params)),
        axios.get(appendParams(`${config.productstats}/total-items`, params)),

        axios.get(
          appendParams(
            `${config.productstats}/detailed-brands${
              sortParamsBrand ? `?sort=${sortParamsBrand}` : ""
            }`,
            params
          )
        ),
        axios.get(
          appendParams(
            `${config.productstats}/detailed-items${
              sortParamsSku ? `?sort=${sortParamsSku}` : ""
            }`,
            params
          )
        ),

        axios.get(
          appendParams(`${config.txnstats}/number-of-transactions`, params)
        ),
        axios.get(
          appendParams(
            `${config.txnstats}/number-of-transactions-per-day`,
            params
          )
        ),
        axios.get(
          appendParams(
            `${config.txnstats}/number-of-successful-transactions`,
            params
          )
        ),
        axios.get(
          appendParams(
            `${config.txnstats}/number-of-successful-uploaders`,
            params
          )
        ),
        axios.get(
          appendParams(`${config.txnstats}/number-of-multiple-uploads`, params)
        ),
        axios.get(
          appendParams(`${config.txnstats}/avg-number-of-transactions`, params)
        ),
        axios.get(
          appendParams(`${config.txnstats}/number-of-registrations`, params)
        ),
        axios.get(
          appendParams(`${config.txnstats}/common-invalid-reasons`, params)
        ),
        axios.get(
          appendParams(
            `${config.txnstats}/number-of-transactions-per-branch`,
            params
          )
        ),
        axios.get(appendParams(`${config.txnstats}/adclicks-per-ref`, params)),
        axios.get(appendParams(`${config.gCashBalance}`, params)),
      ]);

      datas = {
        dailyItems: dailyItems.data,
        totalItems: totalItems.data,
        detailedBrands: detailedBrands.data,
        detailedItems: detailedItems.data,
        totalTransaction: totalTransaction.data.data,
        transactionsPerDay: transactionsPerDay.data.data,
        successfulTransactions: successfulTransactions.data.data,
        successfulUploaders: successfulUploaders.data.data,
        multipleUploaders: multipleUploaders.data.data,
        averageTransaction: averageTransaction.data.data,
        numberOfRegistrations: numberOfRegistrations.data.data,
        commonInvalidReasons: commonInvalidReasons.data.data,
        numberOfTransactionsPerBranch: numberOfTransactionsPerBranch.data.data,
        adclicksPerRef: adclicksPerRef.data.data,
        gCashBalance: gCashBalance.data.data,
      };
      await dispatch(dashboardDatasSuccess(datas));
    } catch (err) {
      await dispatch(dashboardDatasFailed());
    }
  };
};

// FILTER
export const onFilterDashboard = () => {
  return {
    type: actionTypes.FILTER_DASHBOARD_SUCCESS,
  };
};

const filterDashboardResetStart = () => {
  return {
    type: actionTypes.FILTER_DASHBOARD_RESET,
  };
};

export const onFilterDashboardReset = () => {
  return async (dispatch) => {
    await dispatch(filterDashboardResetStart());
    await dispatch(onDashboardDatas());
  };
};
